import React, { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { fetchTimeInterval, getCurrentDate, getCurrentTime, getLookupByKey, isObject, isSet, isVisitInFuture } from "../../utils/commonUtils";
import FormInputs from "../../components/UI/FormInputs";
import withReduxState from "../../hoc/wReduxState";
import WithRoutify from "../../hoc/WithRoutify";
import Buttons from "../../components/UI/Buttons";
import CompanyService from "../../services/CompanyService";
import DropDownService from "../../services/DropDownService";
import VisitsService from "../../services/VisitsService";
import EmrVisitsService from "../../services/EmrVisitsService";
import ActivitiesService from "../../services/ActivitiesService";
import ProviderService from "../../services/ProviderService";
import EmployeeService from "../../services/EmployeeService";
import Wrap from "../../hoc/Wrap";
import { useSelector } from "react-redux";
import { organizationList } from "../../store/OrganizationSlice";
import { VISIT_CATEGORY } from "../../utils/constant";
import EditClinicVisitCategoryConsentForm from "./EditClinicVisitCategoryConsentForm";
import { isCompanyEmployee } from "../../utils/aclUtils";
import { PatientFormModelWithHoc } from "./PatientFormModel";
import { isLaboratoryVisitCategory, isPhysicalVisitCategory } from "../../utils/visitUtils";
import PatientQuestion from "../PatientFormContainer/Forms/PatientQuestion";
import { FieldValidationFocus } from "../../utils/cssUtils";
import AddIncidentModal from "./AddIncidentModal";
import Alert from "../../components/UI/ConfirmBox/Alert";
import moment from "moment";
import AddAuthorizationTreatment from "./AddAuthorizationTreatment";

const AddVisit = (props) => {
  const { Toast,profile } = props;
  const [patientOptions, setPatientOptions] = useState([]);
  const [validation, setValidation] = useState({});
  const [formData, setFormData] = useState({});
  const [activityList, setActivityList] = useState([]);
  const { isOpen, modalToogleHandler, modelTitle } = props;
  const [services, setService] = useState([]);
  const [companyServiceOption, setCompanyServiceOption] = useState([{ label: '-Select Service-', value: '' }]);
  const [physicalServices, setPhysicalServices] = useState([]);
  const [visitCategoryOptions, setvisitCategoryOptions] = useState([]);
  const [visitReasonOptions, setVisitReasonOptions] = useState([]);
  const organizationListOptions = useSelector(organizationList);
  const [companyOptions,setCompanyOption]=useState([]);
  const [showCosentFormModel,setshowConsentFormModel]=useState(false);
  const [showPatientFormModel,setShowPatientFormModel]=useState(false);
  const[showPreRegCode,setShowPreRegCode]=useState(false); 
  const [savedVisit,setSavedVisit]=useState({});
  const [clinicConsentForm,setclinicConsentForm]=useState(null);
  const [patientHealthInformation,setPatientHealthInformation]=useState({});
  const [showIncidentModal,setShowIncidentModal]=useState(false)
  const [showAuthorizationTreatmentModal,setShowAuthorizationTreatmentModal]=useState(false);
  const [employeeHolidays, setEmployeeHolidays] = useState([]);
  const [employeeDisabledDays, setEmployeeDisabledDays] = useState([]);
  const [employeeAvailability, setEmployeeAvailability] = useState([]);
  const [clinicLocationOptions, setClinicLocationOptions] = useState([{ label: "-Select Clinic Location-", value: "" }]);
  const [employeeInitialClinicId, setEmployeeInitialClinicId] = useState("");
  const [showClinicChangeConfirm, setShowClinicChangeConfirm] = useState(false);
  const [pendingClinicChange, setPendingClinicChange] = useState(null);
  const [selectedBodyPart, setSelectedBodyPart] = useState("");
  const [allowedRanges, setAllowedRanges] = useState([]);
  const [showVisitSelectionModal, setShowVisitSelectionModal] = useState(false);
  const [existingVisits, setExistingVisits] = useState([]);
  const [selectedVisitId, setSelectedVisitId] = useState(null);
  const [newFollowUpVisitId, setNewFollowUpVisitId] = useState(null);
  const [loadingVisits, setLoadingVisits] = useState(false);
  const [mappingIncident, setMappingIncident] = useState(false);
  const [incidentAlreadyMapped, setIncidentAlreadyMapped] = useState(false);
  const inputFields=getInputFields();
    const dayNameMap = {
      MON: "Monday",
      TUE: "Tuesday",
      WED: "Wednesday",
      THU: "Thursday",
      FRI: "Friday",
      SAT: "Saturday",
      SUN: "Sunday",
    };
useEffect(() => {
  const autoFillData = props.autoFillData;
  setFormData({
    company_id: autoFillData.company_id,
    employee_id: autoFillData.employee_id,
    clinic_id: autoFillData.clinic_id, // store clinic_id too if passed
    visit_date: isSet(autoFillData.visit_date, getCurrentDate()),
    visit_time: isSet(autoFillData.visit_time,getCurrentTime().toString().padStart(2, '0')),
    service_date: getCurrentDate(),
    standard_services: isSet(autoFillData.visit_date, getCurrentDate()),
  });

  if (isSet(autoFillData.company_id, null) !== null) {
    fetchPatientDetails(autoFillData.company_id, '', () => {});
    fetchVisitCategoryOptions(autoFillData.company_id);
  }
  
  // ✅ NEW LOGIC: Trigger availability fetch
  if (autoFillData.employee_id) {
    fetchEmployeeDetailsAndClinic(autoFillData.employee_id).then((clinicId) => {
      if (clinicId) fetchClinicAvailabilityByClinic(clinicId);
    });
  } else if (autoFillData.clinic_id) {
    fetchClinicAvailabilityByClinic(autoFillData.clinic_id);
  } else if (isSet(props.profile) && isSet(props.profile.role === 'company_employee')) {
    fetchClinicAvailability(props.profile.id);
  }
}, [props.autoFillData]);

useEffect(() => {
  if (
    isSet(props.profile) &&
    isSet(props.profile.role === "company_employee")
  ) {
    const selectedDate = formData.visit_date;
    const dayName = new Date(selectedDate).toLocaleDateString("en-US", {
      weekday: "long",
    });

    const isBlockedDate =
      employeeHolidays.includes(formData.visit_date) ||
      employeeDisabledDays.includes(dayName);
    // console.log('isBlockedDate',isBlockedDate);
    if (isBlockedDate) {
      setFormData((prev) => ({
        ...prev,
        visit_date: "",
      }));
    }

    console.log("selectedDate useEffect", selectedDate, employeeAvailability);
    // Get the day name (e.g., Monday, Tuesday, etc.)
    // const dayName = new Date(selectedDate).toLocaleDateString('en-US', { weekday: 'long' });

    // Find availability for that day
    const matchingDay = employeeAvailability.find(
      (dayObj) => dayNameMap[dayObj.day] === dayName
    );

    if (matchingDay && matchingDay.slots && matchingDay.slots.length > 0) {
      // ✅ If slots are available, format them
      const formattedSlots = matchingDay.slots.map((slot) => ({
        from: slot.from_time,
        to: slot.to_time,
      }));

      setAllowedRanges(formattedSlots);

      // ✅ Check if current visit_time is still valid
      setFormData((prev) => {
        const currentVisitTime = prev.visit_time;

        // If no visit_time selected → no need to clear anything
        if (!currentVisitTime) return prev;

        // Check if visit_time is inside any valid slot
        const isTimeValid = formattedSlots.some((slot) => {
          const visitMoment = moment(currentVisitTime, "hh:mm A");
          const fromMoment = moment(slot.from, "hh:mm A");
          const toMoment = moment(slot.to, "hh:mm A");

          return visitMoment.isBetween(fromMoment, toMoment, null, "[]");
        });

        if (!isTimeValid) {
          return { ...prev, visit_time: "" };
        }

        // ✅ Otherwise, keep the existing visit_time
        return prev;
      });
    } else {
      setAllowedRanges([]);
    }
  }
}, [employeeHolidays, employeeDisabledDays]);


  const fetchClinicAvailabilityByClinic = async (clinicId) => {
  try {
    const clinicDetails = await CompanyService.clinicAvailabilityByClinic(clinicId);
    // Adjust service name to your backend API — if it doesn't exist, 
    // you may need to create it in backend or reuse existing API differently.

    const holidays = clinicDetails?.holidays || [];
    const availability = clinicDetails?.availability || [];

    const activeHolidayDates = holidays
      .filter(h => h.is_active === 1)
      .map(h => h.date);
    setEmployeeHolidays(activeHolidayDates);

    setEmployeeAvailability(availability);
    const disabledDays = availability
      .filter(dayObj => dayObj.is_repeatable === 0)
      .map(dayObj => dayNameMap[dayObj.day] || dayObj.day);
    setEmployeeDisabledDays(disabledDays);

    if (formData.visit_date) {
      const dayName = new Date(formData.visit_date)
        .toLocaleDateString('en-US', { weekday: 'long' });

      const isBlockedDate =
        activeHolidayDates.includes(formData.visit_date) ||
        disabledDays.includes(dayName);

      if (isBlockedDate) {
        setFormData(prev => ({
          ...prev,
          visit_date: ''
        }));
      }
    }
  } catch (err) {
    console.error("Error fetching clinic availability:", err);
  }
};

  useEffect(() => {
    fetchActivities();
    
    if(isSet(props.profile) && !isSet(props.profile.role === 'company_employee')){
      fetchCompaniesList();
    }
    fetchVisitCategory();
    fetchVisitReason();
  }, []);

  // Update companyServiceOption when physicalServices or visit_category changes
  useEffect(() => {
    let opt = [{ label: '-Select Service-', value: '' }];

    // Only populate options if visit_category is set and physicalServices are available
    if (formData.visit_category && physicalServices.length > 0) {
      if (formData.visit_category === 'Employer Services - Physicals') {
        physicalServices.forEach((itm) => {
          opt.push({ label: itm.physical_name, value: itm.company_physical_id });
        });
      } else if (formData.visit_category === 'Employer Services - Drug Screens') {
        let drugScreenEnabled = physicalServices.filter(item => item.drug_screen == 1);
        drugScreenEnabled.forEach((itm) => {
          opt.push({ label: itm.physical_name, value: itm.company_physical_id });
        });
      }
      else if (formData.visit_category === 'Employer Services - DOT Physicals') {
        let dotPhysicalsEnabled = physicalServices.filter(item => item.dot_physicals == 1);
        dotPhysicalsEnabled.forEach((itm) => {
          opt.push({ label: itm.physical_name, value: itm.company_physical_id });
        });
      }
    }

    setCompanyServiceOption(opt);
  }, [physicalServices, formData.visit_category]);
  const fetchCompaniesList = async () => {
    const response=await DropDownService.getCompanies(null);
        let companiesOptions = [{ label: "-Select Company-", value: "" }];
        response.forEach((company) => {
          companiesOptions.push({
            label: company.name,
            value: company.company_uuid,
          });
        });
        setCompanyOption(companiesOptions);
  };
  const fetchVisitCategory=async()=>{
    const key=await getLookupByKey(VISIT_CATEGORY);
    setvisitCategoryOptions(key);
  }

  const fetchVisitReason = async () => {
    const options = await getLookupByKey('Visit Reason');
    setVisitReasonOptions(options);
  };

  
  if (isSet(props.profile.is_multiple_organization, false) === true&& !props.autoFillData.organization_id) {
    inputFields[0].data.unshift(
      {
        type: "SelectList",
        label: "Organization",
        options: organizationListOptions,
        placeholder: "",
        className: "form-control form-control-solid",
        name: "organization",
        value: formData.organization,
      }
    );
  }
  if (isSet(props.profile) && isSet(props.profile.role === 'company_employee')) {
      // Filter out company_id and employee_id fields
      inputFields[0].data = inputFields[0].data.filter(field => field.name !== 'company_id' && field.name !== 'employee_id');
  }
  const fetchActivities = async () => {

    const response = await DropDownService.getActivityDropdownList(null);
    let opt = [{ "label": 'ALL', value: 'ALL' }];
    response.forEach((itm, ind) => {
      opt.push({ label: itm.activity_name, value: itm.actitivity_id,activity_type: itm.activity_type})
    });
    setActivityList(opt);
  }
  const serviceOnchangeHandler = (name, bool, { selectVal }) => {
    let updatedServices = [...services];
    if (bool) {
      if (selectVal === 'ALL') {
        updatedServices = ['ALL'];
      } else {
        updatedServices.push(selectVal);
      }
    } else {
      if (selectVal === 'ALL') {
        updatedServices = [];
      } else {
        let isSelected = services.includes('ALL');
        if (isSelected) {
          updatedServices = activityList.map(itm => itm.value).filter(itm => itm !== selectVal&&itm!='ALL');
        } else {
          updatedServices = updatedServices.filter((value) => value !== selectVal);
        }
      }
    }
    if (activityList.length-1==updatedServices.length) {
      updatedServices = ['ALL'];
    }
    setService(updatedServices);
  };

  // const fetchClinicAvailability = async (employeeId) => {
  //   try {
  //     const empDetails = await CompanyService.clinicAvailability(employeeId);
  //     console.log("Employee details:", empDetails);
  
  //     // ✅ Set holidays
      
  //   // if (empDetails?.holidays) {
  //   //   const holidayDates = empDetails.holidays.map(h => h.date);
  //   //   setEmployeeHolidays(holidayDates);
  //   // }
  //   if (empDetails?.holidays) {
  //     const activeHolidayDates = empDetails.holidays
  //       .filter(h => h.is_active === 1) // only keep active holidays
  //       .map(h => h.date);

  //     setEmployeeHolidays(activeHolidayDates);
  //   }

  //   if (empDetails?.availability) {
  //     setEmployeeAvailability(empDetails.availability);

  //     const disabledDays = empDetails.availability
  //       .filter(dayObj => dayObj.is_repeatable === 0)
  //       .map(dayObj => dayNameMap[dayObj.day] || dayObj.day);
  //     setEmployeeDisabledDays(disabledDays);
  //   }
  // } catch (err) {
  //   console.error("Error fetching employee details:", err);
  // }
  // };
  const fetchClinicAvailability = async (employeeId) => {
    try {
      const empDetails = await CompanyService.clinicAvailability(employeeId);
      // console.log("Employee details:", empDetails);
  
      const holidays = empDetails?.holidays || [];
      const availability = empDetails?.availability || [];
  
      // ✅ Set only active holidays
      const activeHolidayDates = holidays
        .filter(h => h.is_active === 1)
        .map(h => h.date);
      setEmployeeHolidays(activeHolidayDates);
  
      // ✅ Set availability and disabled days
      setEmployeeAvailability(availability);
      const disabledDays = availability
        .filter(dayObj => dayObj.is_repeatable === 0)
        .map(dayObj => dayNameMap[dayObj.day] || dayObj.day);
      setEmployeeDisabledDays(disabledDays);
  
      // ✅ Only check visit_date
      if (formData.visit_date) {
        const dayName = new Date(formData.visit_date).toLocaleDateString('en-US', { weekday: 'long' });
  
        const isBlockedDate =
          activeHolidayDates.includes(formData.visit_date) ||
          disabledDays.includes(dayName);
  
        if (isBlockedDate) {
          setFormData(prev => ({
            ...prev,
            visit_date: ''
          }));
        }
      }
  
    } catch (err) {
      console.error("Error fetching employee details:", err);
    }
  };
  
  
  
  const changeHandler = (fieldName, val) => {

    setValidation({ ...validation, [fieldName]: '' })
    
    // Clinic change: show Alert if switching away from employee's initial clinic
    if (fieldName === "clinic_id") {
      const newClinicId = (typeof val === "object" ? (val?.value ?? val?.id ?? "") : val) ?? "";
      const newId = String(newClinicId).trim();
      if (employeeInitialClinicId && newId && newId !== employeeInitialClinicId) {
        setPendingClinicChange(newId);
        setShowClinicChangeConfirm(true);
        return;
      }
      // Same clinic or no initial - update directly and reload availability
      setFormData((prev) => ({ ...prev, clinic_id: newId }));
      if (newId && props.Loader) {
        props.Loader(true);
        fetchClinicAvailabilityByClinic(newId).finally(() => { if (props.Loader) props.Loader(false); });
      }
      return;
    }

    if (fieldName === 'company_id') {
      setFormData(prevState=>({
        ...prevState,
        employee_id:props.autoFillData.employee_id,
        [fieldName]:val,
        standard_services: '' // Clear contracted service when company changes
      }));
      fetchPatientDetails(val, '', () => { });
      fetchVisitCategoryOptions(val);

    }
    else if (fieldName === 'employee_id') {
      const validEmployeeId = typeof val === 'object' && val !== null
        ? (val.value || val.employee_id || val.id)
        : val;
      const trimmedId = String(validEmployeeId || '').trim();
      const finalEmployeeId = (trimmedId === 'null' || trimmedId === 'undefined' || trimmedId === '') ? null : trimmedId;

      setFormData(prevFormData => ({
        ...prevFormData,
        [fieldName]: finalEmployeeId,
        clinic_id: finalEmployeeId ? prevFormData.clinic_id : "",
      }));

      if (finalEmployeeId) {
        if (props.Loader) props.Loader(true);
        fetchEmployeeDetailsAndClinic(finalEmployeeId)
          .then((clinicId) => (clinicId ? fetchClinicAvailabilityByClinic(clinicId) : Promise.resolve()))
          .finally(() => { if (props.Loader) props.Loader(false); });
      } else {
        setClinicLocationOptions([{ label: "-Select Clinic Location-", value: "" }]);
        setEmployeeInitialClinicId("");
        setEmployeeHolidays([]);
        setEmployeeAvailability([]);
        setEmployeeDisabledDays([]);
        setAllowedRanges([]);
      }
    } else if (fieldName === 'visit_date') {
      const selectedDate = val;
    
      setFormData(prev => ({
        ...prev,
        [fieldName]: selectedDate,
      }));
    
      // Get the day name (e.g., Monday, Tuesday, etc.)
      const dayName = new Date(selectedDate).toLocaleDateString('en-US', { weekday: 'long' });
    
      // Find availability for that day
      const matchingDay = employeeAvailability.find(
        dayObj => dayNameMap[dayObj.day] === dayName
      );
    
      if (matchingDay && matchingDay.slots && matchingDay.slots.length > 0) {
        // ✅ If slots are available, format them
        const formattedSlots = matchingDay.slots.map(slot => ({
          from: slot.from_time,
          to: slot.to_time
        }));
    
        setAllowedRanges(formattedSlots);
    
        // ✅ Check if current visit_time is still valid
        setFormData(prev => {
          const currentVisitTime = prev.visit_time;
    
          // If no visit_time selected → no need to clear anything
          if (!currentVisitTime) return prev;
    
          // Check if visit_time is inside any valid slot
          const isTimeValid = formattedSlots.some(slot => {
            const visitMoment = moment(currentVisitTime, "hh:mm A");
            const fromMoment = moment(slot.from, "hh:mm A");
            const toMoment = moment(slot.to, "hh:mm A");
    
            return visitMoment.isBetween(fromMoment, toMoment, null, "[]");
          });
    
          // ❌ If time is outside slots → clear it
          if (!isTimeValid) {
            return { ...prev, visit_time: "" };
          }
    
          // ✅ Otherwise, keep the existing visit_time
          return prev;
        });
    
      } else {
        // ❌ No slots → keep existing visit_time, just reset allowedRanges
        setAllowedRanges([]);
        // ❌ DO NOT clear visit_time here
      }
    }
     else{
      setFormData(prevFormData => {
        let updatedFormData = {
          ...prevFormData,
          [fieldName]: val,
        };
        if (fieldName === 'visit_category' || fieldName === 'company_id') {
          updatedFormData.standard_services='';
        }
        return updatedFormData;
      });
    }
    if (fieldName === 'visit_category') {
      let opt = [{ label: '-Select Service-', value: '' }];

      if (val == 'Employer Services - Physicals') {
        physicalServices.forEach((itm) => {
          opt.push({ label: itm.physical_name, value: itm.company_physical_id })
        });
      }
      if (val == 'Employer Services - Drug Screens') {
        let drugScreeEnabled = physicalServices.filter(item => item.drug_screen == 1);
        drugScreeEnabled.forEach((itm) => {
          opt.push({ label: itm.physical_name, value: itm.company_physical_id })
        });
      }
      setCompanyServiceOption(opt);

    }
  };
  const fetchVisitCategoryOptions = async (company_id) => {
    if (!company_id) return false; 
    let companyPhysical = await CompanyService.getCompaniesPhysical(company_id);
    let opt = [{ label: '-Select Service-', value: '' }];
    const companyPhysicalData=companyPhysical?.data?.data;
    companyPhysicalData.forEach((itm) => {
      opt.push({ label: itm.physical_name, value: itm.physical_name })
    });
    setPhysicalServices(companyPhysicalData);

  }
  const fetchPatientDetails = async (companyId, val, callback) => {
    let optionsArr = [];
    if (companyId) {
      try {
        const data = await CompanyService.getCompaniesEmployee(companyId, val);
        for (const i in data) {
          optionsArr.push({
            label: data[i],
            value: i
          });
        }
        if (optionsArr.length === 0) {
          setPatientOptions([]);
        } else {
          setPatientOptions(optionsArr);
        }
  
        
      } catch (error) {
        // callback(patientOptions);
        // setIsLoading(false);
      } finally {
        // setIsLoading(false);
      }
    }
    callback(optionsArr);
  };

  const fetchEmployeeDetails = async (employeeId) => {
    if (!employeeId) return;
    try {
      const employeeDetails = await EmployeeService.getEmployee(employeeId);
      if (employeeDetails && employeeDetails.clinic_id) {
        setFormData(prevFormData => ({
          ...prevFormData,
          clinic_id: employeeDetails.clinic_id,
        }));
      }
    } catch (e) {
      console.error('Error fetching employee details:', e);
    }
  };

  // Fetch employee details + clinic list, populate clinic dropdown, pre-select employee's clinic
  const fetchEmployeeDetailsAndClinic = async (employeeId) => {
    if (!employeeId) return "";
    try {
      const [allClinics, employeeDetails] = await Promise.all([
        DropDownService.getClinicList(null),
        EmployeeService.getEmployee(employeeId),
      ]);
      if (!employeeDetails || !employeeDetails.company_id) return "";
      const employee_clinic_id = employeeDetails.clinic_id;
      let clinicOptions = [{ label: "-Select Clinic Location-", value: "" }];
      if (allClinics && Array.isArray(allClinics)) {
        allClinics.forEach((clinic) => {
          clinicOptions.push({
            label: clinic.name || clinic.clinic_name || clinic.clinic_location_name || "Clinic",
            value: clinic.clinic_id || clinic.clinic_uuid || clinic.id,
          });
        });
      }
      setClinicLocationOptions(clinicOptions);
      const clinicId = employee_clinic_id && clinicOptions.some((opt) => opt.value === employee_clinic_id)
        ? employee_clinic_id
        : "";
      setEmployeeInitialClinicId(clinicId || "");
      setFormData((prev) => ({
        ...prev,
        clinic_id: clinicId,
      }));
      return clinicId || "";
    } catch (e) {
      console.error("Error fetching employee details and clinic:", e);
      setClinicLocationOptions([{ label: "-Select Clinic Location-", value: "" }]);
      setEmployeeInitialClinicId("");
      return "";
    }
  };

  const handleClinicChangeConfirm = async () => {
    const clinicId = pendingClinicChange;
    if (clinicId != null) {
      setFormData((prev) => ({ ...prev, clinic_id: clinicId }));
    }
    setShowClinicChangeConfirm(false);
    setPendingClinicChange(null);
    if (clinicId && props.Loader) {
      props.Loader(true);
      try {
        await fetchClinicAvailabilityByClinic(clinicId);
      } finally {
        props.Loader(false);
      }
    }
  };

  const handleClinicChangeCancel = () => {
    setShowClinicChangeConfirm(false);
    setPendingClinicChange(null);
  };

  const fetchProviderList = async (val, clinicId, callback = () => {}) => {
    let optionArr = [];
    if (!clinicId) {
      callback(optionArr);
      return optionArr;
    }
    try {
      const data = await ProviderService.getProviderByClinicId(clinicId, { search: val });
      isSet(data, []).map((item) => {
        optionArr.push({
          label: isSet(item.first_name, "") + " " + isSet(item.last_name, ""),
          value: item.provider_id,
        });
      });
      callback(optionArr);
    } catch (e) {
      console.error('Error fetching providers:', e);
    }
    return optionArr;
  };


  const formSubmitHandler = async () => {
    
    let updateValidation = {};
    let validationErrors = {};
    let isValid = true;
    if ((!formData.company_id || formData.company_id === null) && isSet(props.profile) && !isSet(props.profile.role === 'company_employee')) {
        validationErrors['company_id'] = `The company id field is required`;
        isValid = false;
    }
    if (!formData.employee_id) {
      validationErrors['employee_id'] = "Patient/Employee is required";
      isValid = false;
    }
    if (!formData.clinic_id) {
      validationErrors['clinic_id'] = "Clinic Location is required";
      isValid = false;
    }
    // console.log('formdata',formData,hasEzReader());
    if (hasEzReader()&&formData.visit_category&&!isLaboratoryVisitCategory(formData.visit_category)) {
      if (!formData.hasOwnProperty('cup_id')||formData.cup_id=='') {
        validationErrors['cup_id'] = `The Cup id field is required`;
        isValid = false;
      }
    }
    // Validate Contracted Service is required when Visit Category is "Employer Services - Physicals" or "Employer Services - Drug Screens"
    // Only require if there are options available (more than just the default "-Select Service-" option)
    const hasContractServiceOptions = companyServiceOption.length > 1; // More than just the default option
    if ((formData.visit_category === 'Employer Services - Physicals' || formData.visit_category === 'Employer Services - Drug Screens' || formData.visit_category === 'Employer Services - DOT Physicals') && hasContractServiceOptions) {
      if (!formData.standard_services || formData.standard_services === '') {
        validationErrors['standard_services'] = `The Contracted Service field is required`;
        isValid = false;
      }
    }
    if (!isValid) {
        setValidation({
            ...updateValidation,
            ...validationErrors
        });
        // Combine inputFields and VisitCatagoryField for FieldValidationFocus
        const allFields = [...inputFields, ...VisitCatagoryField];
        FieldValidationFocus(allFields, validationErrors);
        return false;
    }
    
    // Always send the selected clinic (Clinic Location) for easier debugging and consistent backend handling
    const currentClinicId = formData.clinic_id || "";
    let payload = {
      ...formData,
      ['optional_services']: services.join(','),
    };
    if (currentClinicId) {
      payload.assigned_clinic_id = currentClinicId;
    }
    //if payload.optional_services have all get all value     
    if (payload.optional_services === "ALL") {
      //get all value
      let allActivityList = activityList.map(itm => itm.value);
      //filter all value 
      let filterAllActivityList = allActivityList.filter(itm => itm != "ALL");
      //append 
      payload = {
        ...formData,
        ['optional_services']: filterAllActivityList.join(',')
      };
    }
    if (formData.visit_category === "Employer Services - Physicals") {
      const healthInformation = {
        ...patientHealthInformation,
        patient_id:formData.employee_id,
        company_id:formData.company_id,
        visit_mapping_id:null,          
      };
      payload.healthInformation = healthInformation;
    }
    if (payload.visit_category) {
      if (isLaboratoryVisitCategory(payload.visit_category)) {
        delete payload.optional_services;
        delete payload.cup_id;
        delete payload.standard_services;
      }
    }
    
    // Check if visit date and time is in the future, set status to "Scheduled"
    if (payload.visit_date && payload.visit_time) {
      if (isVisitInFuture(payload.visit_date, payload.visit_time)) {
        payload.visit_status = 'Scheduled';
      }
    }
    
    try {
      props.Loader(true);
      const data = await VisitsService.saveVisits(isSet(formData.organization, null), payload);
      if (data.status && data.status === "ERROR") {
        if (isObject(data.data)) {
          for (let key in data.data) {
            updateValidation = {
              ...updateValidation,
              [key]: data.data[key].join(","),
            };
          }
        } else {
          props.Toast.error(data.data);
        }
        if (Object.keys(updateValidation).length > 0) {
          setValidation(updateValidation);
          // Combine inputFields and VisitCatagoryField for FieldValidationFocus
          const allFields = [...inputFields, ...VisitCatagoryField];
          FieldValidationFocus(allFields, updateValidation);         
        }
      } else {
        const savedVisitData = await VisitsService.getVisits(data.visit_id);
        const savedVisit=savedVisitData[0]
        setSavedVisit(savedVisit);
        setclinicConsentForm(savedVisit.snapVisitConsentForm !=null ? savedVisit.snapVisitConsentForm : savedVisit.snapClinicConsentForm);
        
        // Check if visit category is "Work Comp - Follow Up"
        if ((formData.visit_category === "Work Comp - Follow Up" || formData.visit_category === "Work Comp - Physical Therapy" || formData.visit_category === "Work Comp - Other") && data.visit_id && formData.employee_id) {
          setNewFollowUpVisitId(data.visit_id);
          await fetchExistingVisits(data.visit_id, formData.employee_id);
          setShowVisitSelectionModal(true);
        } else {
          if (isCompanyEmployee(props.profile.role)) {
            editConsentHandler(false);
          }else if(props.profile?.employer_login===true){
            authorizationToogleHandler(true);
          }else{
            patientFormToogleHandler();
          }
          Toast.success('Visit Added Successfully');
        }
      }
      props.Loader(false);
    } catch (e) {

    }

  }
  const incidentToogleHandler=()=>{
        setShowIncidentModal(false)
        props.fetchVisitsList();
        props.modalToogleHandler(true);
  }

  const fetchExistingVisits = async (excludeVisitId, employeeId) => {
    if (!employeeId) return;
    
    setLoadingVisits(true);
    try {
      const response = await VisitsService.getEmployeeVisitsNotDischarged({
        employee_id: employeeId,
        exclude_visit_id: excludeVisitId
      });
      
      if (response?.code === 200 && response?.data) {
        setExistingVisits(response.data);
      } else {
        setExistingVisits([]);
      }
    } catch (error) {
      console.error("Error fetching visits:", error);
      setExistingVisits([]);
    } finally {
      setLoadingVisits(false);
    }
  }

  const handleVisitSelect = (visit) => {
    setSelectedVisitId(visit.visit_id);
  }

  const handleMapIncident = async () => {
    if (!selectedVisitId || !newFollowUpVisitId) {
      Toast.error("Please select a visit");
      return;
    }

    setMappingIncident(true);
    try {
      const response = await EmrVisitsService.mapVisitIncident(newFollowUpVisitId, {
        pre_visit_id: selectedVisitId
      });

      if (response?.code === 200) {
        Toast.success("Incident mapped successfully");
        setIncidentAlreadyMapped(true);
        setShowVisitSelectionModal(false);
        if (isCompanyEmployee(props.profile.role)) {
          editConsentHandler(false);
        }else if(props.profile?.employer_login===true){
          authorizationToogleHandler(true);
        }else{
          patientFormToogleHandler();
        }
        props.fetchVisitsList?.();
      } else {
        Toast.error(response?.data?.error || "Failed to map incident");
      }
    } catch (error) {
      console.error("Error mapping incident:", error);
      Toast.error("Error mapping incident");
    } finally {
      setMappingIncident(false);
    }
  }

  const handleSkipMapping = () => {
    setShowVisitSelectionModal(false);
    if (isCompanyEmployee(props.profile.role)) {
      editConsentHandler(false);
    }else if(props.profile?.employer_login===true){
      authorizationToogleHandler(true);
    }else{
      patientFormToogleHandler();
    }
    Toast.success('Visit Added Successfully');
  }

  const authorizationToogleHandler = (val = false) => {

    setShowAuthorizationTreatmentModal(val)

      setTimeout(() => {
        patientFormToogleHandler(true)
      }, 250);


  }
  // console.log('props.profile.role',props.profile.role);
  const patientFormToogleHandler=(closeVisitForm=false)=>{
    console.log('closeVisitForm',closeVisitForm); 
    if (closeVisitForm) {
      console.log('savedVisit',savedVisit);
      // props.fetchVisitsList();
      // props.modalToogleHandler();
      // Define visit categories that require incident modal
      const workCompCategories = ['Work Comp - New Injury', 'Work Comp - Follow Up'];
      const urgentCareCategories = ['Urgent Care - Injury', 'Urgent Care - Illness', 'Urgent Care - Follow Up', 'Urgent Care - Cash Patient', 'Urgent Care - Telehealth'];
      const privateCategories = ['Private - Mental Health Exam', 'Private - Primary Care - Initial', 'Private - Primary Care - Follow Up'];
      const incidentRequiredCategories = [...workCompCategories, ...urgentCareCategories, ...privateCategories];
      
      // For Work Comp - Follow Up, skip incident modal if incident was already mapped
      if(incidentRequiredCategories.includes(savedVisit.visit_category) && 
         (savedVisit.visit_category!=='Work Comp - Follow Up' || !incidentAlreadyMapped)){
         setShowIncidentModal(true);
      } else {
        props.fetchVisitsList();
        props.modalToogleHandler(true);
      }
      
    }
    setShowPatientFormModel(!showPatientFormModel);
  }
  const editConsentHandler=(closeVisitForm=true)=>{
    if (closeVisitForm||clinicConsentForm==null) {
      // if (showPreRegCode==false) {
      //   setshowConsentFormModel(false);
      //   // setShowPreRegCode(true);
      //   // return;
      // }
      props.fetchVisitsList();
      props.modalToogleHandler(true);
    }
    setshowConsentFormModel(!showCosentFormModel);
  }
  const patientHealthInformationChangeHandler=(name,val,formdata)=>{
    if (formdata!=null) {
      setPatientHealthInformation(formdata);
      return;
    }
    setPatientHealthInformation({...patientHealthInformation,[name]:val});
  }
  const hasEzReader = () => {
    if (services) {
      if (services.includes('ALL')) { //if optional service is all
        return true;
      } else {
        const selectedActivity = activityList.filter(activity => services.includes(activity.value));
        if (selectedActivity.some(activity => activity.activity_type === 'Drug Screen - EZ-Reader')) { //if optional service has ez
          return true;
        }
      }
    }
  
    if (formData['standard_services']) {
      const service = physicalServices.find(item => item.company_physical_id === formData['standard_services']);
      if (service) {
        return service.has_ezreader; //standard service has ezreader
      }
    }
  
    return false;
  };
  
  
  
  const VisitCatagoryField = [
    {
      label: 'Contracted Services',
      data: [
        {
          label:"Contracted Service",
          type: "SelectList",
          options: companyServiceOption,
          className: "form-control form-control-solid",
          col:"col-6",
          name: "standard_services",
          value: formData['standard_services'],
          required: (formData.visit_category === 'Employer Services - Physicals' || formData.visit_category === 'Employer Services - Drug Screens' || formData.visit_category === 'Employer Services - DOT Physicals') && companyServiceOption.length > 1,
          onchangeHandler: changeHandler
        },
         {
          type: "",
          label:"Cup Id",
          className: "form-control form-control-solid",
          col:"col-6",
          name: "cup_id",
          value: formData['cup_id'],
          placeholder:"Cup ID",
          isShow:hasEzReader(),
          required:true,
          onchangeHandler: changeHandler
        },
      ]
    },
    {
      label: 'Additional Services / Activities',
      data: [
        {
          type: "MultiSelectDropDown",
          options: activityList,
          className: "form-control form-control-solid",
          name: "optional_services",
          value: services,
          onchangeHandler: serviceOnchangeHandler

        },

      ]
    }
  ];
  console.log("showPatientFormModel",showPatientFormModel);
  
  const getStatusBadge = (status) => {
    let badgeClass = 'sh_badgePending';
    let color = '#1D2433CC';
    
    switch (status) {
      case 'Complete & Discharged':
        badgeClass = 'sh_badgeSuccess';
        color = '#0F8647';
        break;
      case 'In Progress':
        badgeClass = 'sh_badgeWarning';
        color = '#CA8B14';
        break;
      case 'Cancelled':
      case 'In Active':
        badgeClass = 'sh_badgeDanger';
        color = '#E02D3C';
        break;
      case 'Scheduled':
        badgeClass = 'sh_badgePending';
        color = '#1D2433CC';
        break;
      default:
        badgeClass = 'sh_badgePending';
        color = '#1D2433CC';
    }

    return (
      <span className={`badge ${badgeClass}`}>
        <span className="pr-1">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="4" cy="4" rx="4" ry="4" fill={color}></ellipse>
          </svg>
        </span>
        {status || '-'}
      </span>
    );
  };
  
  return (
    <>
      {
        showCosentFormModel == true && clinicConsentForm ?
          <EditClinicVisitCategoryConsentForm
            isOpen={true}
            visitId={savedVisit.visit_id}
            snapClinicConsentForm={clinicConsentForm}
            visit_category={formData.visit_category}
            snapEmployeeDetails={savedVisit.employee}
            snapCompanyDetails={savedVisit.company}
            editConsentHandler={editConsentHandler}
            organizationLogo={savedVisit.organizationLogo}

          />
          : ""
      }
      {
        showPreRegCode?
        <Modal 
        show={false}
        // size='xl'
        // dialogClassName='hResponsive'
        contentClassName='h-100'
        backdrop="static"
        keyboard={false}>
          <Modal.Header
          style={{borderBottom : 'none',padding : '0.5rem'}}
          >

          </Modal.Header>
            <Modal.Body>

             <div className="text-center">
             <svg
                        id="Layer_1"
                        width="32px"
                        height="32px"
                        fill="green"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 457.57"
                    >
                        <defs>
                            <style>{".cls-1{fill-rule:evenodd;}"}</style>
                        </defs>
                        <path
                            className="cls-1"
                            d="M0,220.57c100.43-1.33,121-5.2,191.79,81.5,54.29-90,114.62-167.9,179.92-235.86C436-.72,436.5-.89,512,.24,383.54,143,278.71,295.74,194.87,457.57,150,361.45,87.33,280.53,0,220.57Z"
                        />
                    </svg>
               <h6 className="text-lg font-weight-bold mb-2"> Your Pre-Registration is Complete </h6>

              <p>Please take note of the pre-registration code below. When you arrive at the clinic, show the front desk this code to be expedited</p>
              <div className="text-lg font-weight-bold"> {
                savedVisit?.pre_reg_code
              }
              </div>
              </div>
            </Modal.Body>
            <Modal.Footer
            className="d-flex justify-content-center"
            >
            <Buttons
              type='Single'
              className="btn btn-primary"
              clickHandler={()=>editConsentHandler(true)}
              label='Done'
              acl={'any'} 
              />
            </Modal.Footer>
        </Modal>
        :
        ''

      }
      { showIncidentModal ? 
      <AddIncidentModal incidentToogleHandler = {incidentToogleHandler} isOpen={showIncidentModal} visitId={savedVisit.visit_id} savedVisit={savedVisit} employeeDetails={savedVisit.employee} selectedBodyPart={selectedBodyPart} setSelectedBodyPart={setSelectedBodyPart} visitCategory={savedVisit.visit_category}/>
       
      : showAuthorizationTreatmentModal ?
          <AddAuthorizationTreatment
            isOpen={showAuthorizationTreatmentModal}
            authorizationToogleHandler={(val) => authorizationToogleHandler(val)}
            visitId={savedVisit.visit_id}
            savedVisit={savedVisit}
            employeeDetails={savedVisit.employee}
            profile={props.profile}
          />
     
     :<>
      {showClinicChangeConfirm && (
        <Alert
          type="warning"
          custonTitle="Clinic Location Change"
          contentTitle="This Employee Was Initially Seen at a Different Clinic Location. Please Verify That the Location Change Is Authorized Before Proceeding."
          yesButtonName="OK"
          noButtonName="Cancel"
          confirmButtonClassName="btn btn-primary"
          cancelButtonClassName="btn btn-secondary"
          onClose={handleClinicChangeCancel}
          onDelete={handleClinicChangeConfirm}
        />
      )}
      {
        showPatientFormModel &&
          <PatientFormModelWithHoc
            isOpen={showPatientFormModel}
            visitId={savedVisit.visit_id}
            visitData={savedVisit}
            modalToogleHandler={patientFormToogleHandler}
            visitCategory={formData.visit_category}
            services={services}
            contractService={formData.standard_services}
            activityList={activityList}
            physicalServices={physicalServices}
          />
         }
      <Modal
        show={true}
        onHide={()=>modalToogleHandler(true)}
        size='xl'
        dialogClassName='hResponsive'
        contentClassName='h-100'
        backdrop="static"
        keyboard={false}
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 className="text-lg mb-0 font-weight-bold">
                {modelTitle}  for Existing Patient
              </h6>
            </Modal.Title>
            <div className="ml-auto mr-2">{props.headerButton}</div>
          </Modal.Header>
          <Modal.Body
          className="pt-0"
          >
            <div className="row">
              {inputFields &&
                inputFields.map((sec, index) => (
                  <div className='col-12' key={index}>
                    <h6 className="text-md border-bottom pt-3 ">{sec.title}</h6>
                    <div className="row">
                      {sec.data.map((field, fieldIndex) => {
                        if (isSet(field.access, '') == 'HIDDEN') { return false; }
                        const col = isSet(field.col, 'col-6');
                        const value = isSet(formData[field.name], '');
                        return (
                          <div className={`${col}`} key={fieldIndex}>
                            <div className={`form-group ${isSet(field.isLabelAppend, false) === true ? 'form-check form-check-solid' : ''}`} >
                              {(isSet(field.isLabelAppend, false) === false) ?
                                <label className=" text-sm opacity-75 text-truncate mb-0">
                                  {field.label}
                                </label>
                                : <></>}

                              <FormInputs {...field} id={isSet(field.id,field.name)}   changeHandler={(value, e) => changeHandler(field.name, value)} value={value} />
                              {(isSet(field.isLabelAppend, false) === true) ?
                                <label className="form-check-label" htmlFor={field.name}>
                                  {field.label}
                                </label>
                                : <></>}
                              {isSet(validation[field.name], "") !== "" ? (
                                <span className="text-danger m-1">
                                  {isSet(validation[field.name], "")}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )

                      })}
                    </div>
                  </div>
                ))}
            </div>
            {!(isSet(props.profile) && isSet(isCompanyEmployee(profile.role))) && formData.visit_category&&!isLaboratoryVisitCategory(formData.visit_category) && VisitCatagoryField.map((section, secIndex) => {
              return (
                <Wrap>
                <h6 className="text-md border-bottom">{section.label}</h6>
                <div className="row">
                  {section.data.map((item, itemIndex) => (
                    isSet(item.isShow, true) && (
                      <div className={isSet(item.col ||"col-lg-12 col-6"  )} key={itemIndex}>
                        <div className="form-group">
                          <div className={item.type === 'MultiSelectDropDown' ? 'd-flex' : ''}>
                            <label className="text-sm opacity-75 text-truncate mb-0">
                              {item.label}
                            </label>
                            <FormInputs
                              {...item}
                              id={isSet(item.id,item.name)}  
                              changeHandler={(...args) => item.onchangeHandler(item.name, ...args)}
                            />
                          </div>
                          {isSet(validation[item.name], "") !== "" ? (
                                <span className="text-danger m-1">
                                  {isSet(validation[item.name], "")}
                                </span>
                              ) : (
                                ""
                              )}
                        </div>
                      </div>
                    )
                  ))}
                </div>
              </Wrap>
              
              )
            })}
  
              <Wrap>
                <h6 className="text-md border-bottom">Record ID</h6>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label className="text-sm opacity-75 text-truncate mb-0">
                        Record ID
                      </label>
                      <FormInputs
                        type="TextInput"
                        className="form-control form-control-solid"
                        name="record_id"
                        value={formData['record_id']}
                        placeholder="Record ID"
                        changeHandler={(val) => changeHandler('record_id', val)}
                      />
                      {isSet(validation['record_id'], "") !== "" ? (
                        <span className="text-danger m-1">
                          {isSet(validation['record_id'], "")}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </Wrap>
           
          {formData.visit_category&&isPhysicalVisitCategory(formData.visit_category)&&isCompanyEmployee(props.profile.role)&&
           <PatientQuestion
            formData={patientHealthInformation}
            onChangeHandler={(name,val)=>patientHealthInformationChangeHandler(name,val,null)}
            bulkOnChangeHandler={(formData)=>patientHealthInformationChangeHandler(null,null,formData)}
            />
           }
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
            <Buttons
              type='Single'
              className="btn btn-primary"
              clickHandler={() => formSubmitHandler()}
              label='Save'
              acl={'any'} 
              />
          </Modal.Footer>
        </div>
      </Modal>

      {/* Visit Selection Modal for Work Comp Follow Up */}
      <Modal
        show={showVisitSelectionModal}
        onHide={handleSkipMapping}
        dialogClassName="hResponsive"
        keyboard={false}
        backdrop="static"
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 className="text-lg mb-0 font-weight-bold">Select Existing Visit to Map Incident</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingVisits ? (
              <div className="text-center p-4">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : existingVisits.length === 0 ? (
              <div className="text-center p-4">
                <p className="text-muted">No existing visits found for this employee.</p>
              </div>
            ) : (
              <div className="sh_cardBox">
                <div className="sh_cardBody p-0">
                  <div className="table-responsive">
                    <table className="table sh_table">
                      <thead>
                        <tr>
                          <th>Select</th>
                          <th>Visit Date</th>
                          <th>Visit Time</th>
                          <th>Visit Category</th>
                          <th>Visit Status</th>
                          <th>Visit Reason</th>
                          <th>Record ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {existingVisits.map((visit) => (
                          <tr 
                            key={visit.visit_id}
                            onClick={() => handleVisitSelect(visit)}
                            style={{ cursor: 'pointer' }}
                            className={selectedVisitId === visit.visit_id ? 'table-primary' : ''}
                          >
                            <td>
                              <input
                                type="radio"
                                name="visitSelection"
                                checked={selectedVisitId === visit.visit_id}
                                onChange={() => handleVisitSelect(visit)}
                              />
                            </td>
                            <td>{visit.visit_date || '-'}</td>
                            <td>{visit.visit_time || '-'}</td>
                            <td>{visit.visit_category || '-'}</td>
                            <td>{getStatusBadge(visit.visit_status)}</td>
                            <td>{visit.visit_reason || '-'}</td>
                            <td>{visit.record_id || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Buttons
              type='Single'
              className="btn btn-secondary"
              clickHandler={handleSkipMapping}
              label='Skip'
              disabled={mappingIncident}
            />
            <Buttons
              type='Single'
              className="btn btn-primary"
              clickHandler={handleMapIncident}
              label={mappingIncident ? 'Mapping...' : 'Map Incident'}
              disabled={!selectedVisitId || mappingIncident}
            />
          </Modal.Footer>
        </div>
      </Modal>
      </>
      }
    </>
  );
  function getInputFields(){
    const inputFields = [
      {
        title: 'Visit details',
        data: [
          {
            type: "SelectList",
            label: "Company",
            placeholder: "Company",
            className: "form-control form-control-solid",
            name: "company_id",
            col: 'col-6',
            access: (props.autoFillData && Object.entries(props.autoFillData).length > 0 && isSet(props.autoFillData.company_id,null)!==null) ? 'HIDDEN' : '',
            options: companyOptions ,
            disabled: (props.autoFillData && Object.entries(props.autoFillData).length > 0 && isSet(props.autoFillData.company_id,null)!==null) ? true : false,
            required: true,
          },
          {
            type: "SelectSearchList",
            label: "Patient/Employee",
            placeholder: "Patient/Employee",
            className: "form-control form-control-solid",
            name: "employee_id",
            col: 'col-6',
            access: (props.autoFillData && Object.entries(props.autoFillData).length > 0 && isSet(props.autoFillData.employee_id,null)!==null) ? 'HIDDEN' : '',
            isAsync: true,
            loadCallBack: (val, callback) => fetchPatientDetails(formData.company_id, val, callback),
            options: patientOptions,
            reload: formData.company_id,
            isCacheNeeded:false,
            readOnly: isSet(formData.company_id, null || (props.autoFillData && Object.entries(props.autoFillData).length > 0  && isSet(props.autoFillData.employee_id,null)!==null)) === null ? true : false,
            required: true,
          },
          {
            type: "SelectList",
            label: "Clinic Location",
            placeholder: "Clinic Location",
            className: "form-control form-control-solid",
            name: "clinic_id",
            col: "col-6",
            options: clinicLocationOptions,
            required: true,
            readOnly: !formData.employee_id,
          },
          {
            type: "Date",
            label: "Visit Date",
            col: 'col-6',
            placeholder: "Visit Date",
            className: "form-control form-control-solid",
            name: "visit_date",
            required: true,
            disabledDates: employeeHolidays,
            disabledDays: employeeDisabledDays
          },
          {
            type: "SelectSearchList",
            label: "Visit Time",
            col: 'col-6',
            placeholder: "Visit Time",
            isAsync: true,
            options: [{ 'label': getCurrentTime(), value: getCurrentTime() }],
            loadCallBack: (val, callback) => fetchTimeInterval(val, callback ,allowedRanges),
            className: "form-control form-control-solid",
            name: "visit_time",
            reload:formData.visit_time,
          },
          {
            type: "SelectList",
            label: "Reason for Visit",
            col: 'col-6',
            placeholder: "",
            className: "form-control form-control-solid",
            name: "visit_reason",
            options: visitReasonOptions,
          },
          {
            type: "SelectList",
            label: "Visit Category",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "visit_category",
            col: 'col-6',
            options:visitCategoryOptions,
            required: true,
          },
          {
            type: "SelectSearchList",
            label: "Primary Provider",
            placeholder: formData.clinic_id ? "Select Provider" : "Select Patient/Employee first",
            className: "form-control form-control-solid",
            name: "primary_provider_id",
            col: 'col-6',
            isAsync: true,
            options: [],
            loadCallBack: (val, callback) => fetchProviderList(val || '', formData.clinic_id, callback),
            reload: formData.clinic_id,
            value: formData['primary_provider_id'],
            disabled: !formData.clinic_id,
          },
          // {
          //   type: "",
          //   label: "Record ID",
          //   className: "form-control form-control-solid",
          //   col: "col-6",
          //   name: "record_id",
          //   value: formData['record_id'],
          //   placeholder: "Record ID",
          //   isShow: true,
          //   required: false,
          // },
        ]
      },
    ];
    return inputFields;
  }
};
AddVisit.defaultProps = {
  headerButton:<></>
}
export default withReduxState(WithRoutify(AddVisit));